export enum WorkflowTarget {
  TransactionFinished,
  Test
}

export const WorkflowTargetLabels: { [key: number]: string } = {
  [WorkflowTarget.TransactionFinished]: "Transaktion abgeschlossen"
}
